import { GET_HASH_KEY } from "../constants/requestUrls";
import { getRequest } from "../request";

const GetHashKey = () => {
    return getRequest({url:GET_HASH_KEY});
}

export default GetHashKey;